// extracted by mini-css-extract-plugin
module.exports = {"helpIcon":"HelpIcon_helpIcon__Odc1m"};